import Grid from '@mui/material/Grid';
import { Box, CircularProgress, Typography } from '@mui/material';
import { useState } from 'react';
import DataTable from 'widgets/datagrid/DataTable';
import { connect } from 'react-redux';
import FiltroStripe from './components/FiltroStripe';
import { useTransactionsStripeHook } from './hooks/useTransactionsStripeHook';
import { stripeAction } from '_models/redux/list-transactions-stripe/action';
import { cleanStripeAction } from '_models/redux/list-transactions-stripe/clean-action';
import { actionReportTransactionsFraud } from '_models/redux/report-transaction-fraud/action';
import { cleanReportTransactionsFraud } from '_models/redux/report-transaction-fraud/clean_action';
import { cleanReportPrepaidChargebackDetails } from '_models/redux/report-transaction-chargeback/clean_action';
import { actionReportTransactionsChargeback } from '_models/redux/report-transaction-chargeback/action';
import TransactionDetailsStripe from './components/TransactionDetailsStripe';
import { detailStripeAction } from '_models/redux/detail-transactions-stripe/action';
import { cleanDetailStripeAction } from '_models/redux/detail-transactions-stripe/clean-action';
import FraudConfirmationDialog from './components/FraudConfirmationDialog';
import CustomDialog from 'widgets/component/CustomDialog';
const PageTransactionStripe = ({
  stripeAction,
  cleanStripeAction,
  listStripe,
  cleanDetailStripeAction,
  detailStripeAction,
  detailTransactionsStripe,
  actionReportTransactionsFraud,
  cleanReportTransactionsFraud,
  reportTransactionsFraud,
  reportTransactionsChargeback,
  cleanReportPrepaidChargebackDetails,
  actionReportTransactionsChargeback,
  transactionId,
  onClose,
}) => {
  const {
    register,
    handleSubmit,
    errors,
    onSubmit,
    handleCleanFilters,
    loading,
    page,
    size,
    pagination,
    mappedRows,
    handleRowClick,
    Columns,
    handleClose,
    isDialogOpenDetails,
    errorMessage,
    isDialogOpen, //aqui
    dialogTitleMessage,
    dialogMessage,
    openActionFraud,
    setDescriptionTransaction,
    setError,
    error,
    handleConfirm,
    loadingFraudAndChargeback,
    isError,
    handleCloseFraudChargeback, //aqui
    setOpenActionFraud,
    handleOpenPopUp,
    setIdReverso,
    setActiveAction,
    setShouldReturnData,
    activeAction,
    shouldReturnData,
  } = useTransactionsStripeHook({
    stripeAction,
    listStripe,
    cleanStripeAction,
    detailStripeAction,
    cleanDetailStripeAction,
    detailTransactionsStripe,
    actionReportTransactionsFraud,
    cleanReportTransactionsFraud,
    reportTransactionsFraud,
    reportTransactionsChargeback,
    cleanReportPrepaidChargebackDetails,
    actionReportTransactionsChargeback,
    transactionId,
    onClose,
  });
  const [hasSearched, setHasSearched] = useState(false);
  const onSubmitWithFlag = (...args) => {
    setHasSearched(true);
    return onSubmit(...args);
  };
  return (
    <Box>
      <Grid>
        <h4>Transacciones de Stripe</h4>
      </Grid>
      <Box sx={{ mb: 4 }}>
        <FiltroStripe
          onSubmit={onSubmitWithFlag}
          handleSubmit={handleSubmit}
          errors={errors}
          register={register}
          onCleanFilters={handleCleanFilters}
        />
        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
      </Box>
      {loading && <CircularProgress />}
      {mappedRows?.length > 0 ? (
        <Grid paddingLeft={0}>
          <Box>
            <DataTable
              rows={mappedRows}
              columns={Columns}
              onRowClick={handleRowClick}
              page={page}
              pageSize={size}
              rowCount={pagination?.total_rows ?? 0}
              onPageChange={pagination?.handleChangePage}
              handleChangePageSize={pagination?.handleChangePageSize}
              loading={loading}
            />
          </Box>
        </Grid>
      ) : (
        !loading &&
        mappedRows.length === 0 &&
        hasSearched && <Typography variant='h6'>No hay registros disponibles</Typography>
      )}
      <TransactionDetailsStripe
        open={isDialogOpenDetails}
        onClose={handleClose}
        loading={loading}
        detailTransactionsStripe={detailTransactionsStripe}
        handleOpenPopUp={handleOpenPopUp}
        setOpenActionFraud={setOpenActionFraud}
        setIdReverso={setIdReverso}
        setActiveAction={setActiveAction}
        setShouldReturnData={setShouldReturnData}
        activeAction={activeAction}
        shouldReturnData={shouldReturnData}
      />
      <CustomDialog
        title={dialogTitleMessage}
        content={<p>{dialogMessage}</p>}
        open={isDialogOpen}
        onClose={handleClose}
        fullWidth
        maxWidth='sm'
        extraButtons={[
          {
            label: 'Aceptar',
            variant: 'contained',
            onClick: handleClose,
            buttonColor: 'purple',
            textColor: 'white',
          },
        ]}
      />
      <FraudConfirmationDialog
        open={openActionFraud}
        onClose={handleCloseFraudChargeback}
        setDescriptionTransaction={setDescriptionTransaction}
        setError={setError}
        error={error}
        handleConfirm={handleConfirm}
        loadingFraudAndChargeback={loadingFraudAndChargeback}
        dialogMessage={dialogMessage}
        isError={isError}
      />
    </Box>
  );
};
const mapStateToProps = (state) => ({
  listStripe: state?.listStripe,
  detailTransactionsStripe: state?.detailTransactionsStripe,
  reportTransactionsFraud: state?.reportTransactionsFraud,
  reportTransactionsChargeback: state?.reportTransactionsChargeback,
});
const mapDispatchToProps = {
  stripeAction,
  cleanStripeAction,
  cleanDetailStripeAction,
  detailStripeAction,
  actionReportTransactionsFraud,
  cleanReportTransactionsFraud,
  cleanReportPrepaidChargebackDetails,
  actionReportTransactionsChargeback,
};
export default connect(mapStateToProps, mapDispatchToProps)(PageTransactionStripe);
